import $ from 'jquery';
import { prepareChessboard, restrictMove, validateMove, showMagnus, loadNextConfiguration, validateDrag, plotArrow, validateDrop } from "../../utils";
import { WHITE_PIECE_SEARCH_KEY, BLACK_INITIAL_MOVE, CORRECT_ANSWER_AUDIO, WRONG_ANSWER_AUDIO, ACTIVITY_SUCCESS_AUDIO } from '../../utils/constants';
import ChessBoard from '../../components/chessBoard';
import User from '../../classes/user';

/**
 * @name lesson20Assignment1
 * @function
 * @param { config }
 * @description: Select all moves.
 */

export function lesson20Assignment1(config) {
    let next = config.next,
        initialBoardPosition = config.position,
        finalBoardPosition = config.finalPosition,
        timer, timer1, timer2, timer3,
        results = config.resultFen,
        squares = [1, 2, 3, 4, 5],
        count = 0,
        pieces = ['a6', 'b8', 'c8', 'd8'],
        star = 0,
        offsetFromx = null,
        offsetFromy = null,
        offsetTox = null,
        offsetToy = null;

    if (config.offset) {
        offsetFromx = config.offset[0]
        offsetFromy = config.offset[1]
        offsetTox = config.offset[2]
        offsetToy = config.offset[3]
    }

    let afterLoad = function () {
        $(function () {
            let body = `<div class='right-content-holder'>
                <div class='square-box' id='box-1'><p class='box-content'>1</p></div>
                <div class='square-box' id='box-2'><p class='box-content'>2</p></div>
                <div class='square-box' id='box-3'><p class='box-content'>3</p></div>
                <div class='square-box' id='box-4'><p class='box-content'>4</p></div>
                <div class='square-box' id='box-5'><p class='box-content'>5</p></div>
            </div>`;
            $('.right-box-content').html(body);
            $('.next-btn-container #next').click(function () {
                $('.right-content-holder').remove();
            });
            $('.back-btn-container #previous').click(function () {
                $('.right-content-holder').remove();
            });
        })
        prepareChessboard(config);
        $('.next-btn-container #next, .back-btn-container #previous').click(function () {
            star = 0;
            clearTimeout(timer); clearTimeout(timer1); clearTimeout(timer2); clearTimeout(timer3);
            results = [
                'r1bqkbnr/1p1npp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R',
                'r1bqkbnr/1p2pp1p/p1np2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R',
                'rn1qkbnr/1p1bpp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R',
                'rnb1kbnr/1p1qpp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R',
                'rnbqkbnr/1p2pp1p/3p2p1/1pp5/3PP3/2N2N2/PPP2PPP/R1BQK2R'
            ]
        });
        firstComputerMove();
        timer = setTimeout(function () {
            showMagnus({
                data: config.magnusText,
                position: 'left',
                styleClass: 'xxl'
            }, 1000)
        }, 5000)
    }

    let onDragStart = function (source, piece, position, orientation) {
        return restrictMove(piece, WHITE_PIECE_SEARCH_KEY);
    }


    function firstComputerMove() {
        timer1 = setTimeout(function () {
            ChessBoard.board.move(`${config.from}-${config.to}`);
        }, 2000);
        timer2 = setTimeout(function () {
            $('#myCanvas').addClass('show').removeClass('hide');
            var c = document.getElementById("myCanvas");
            var ctx = c.getContext("2d");
            ctx.clearRect(0, 0, c.width, c.height);
            plotArrow(ctx, config.arrowFrom, config.arrowTo, offsetFromx, offsetFromy, offsetTox, offsetToy, null, null, "#cc0000");
        }, 3000);
        timer3 = setTimeout(function () {
            $('#myCanvas').addClass('hide').removeClass('show');
        }, 6000);
    }

    function hideMagnus() {
        setTimeout(function () {
            $(document).trigger('bubble-hide');
        }, 3000)
    }

    let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
        if (validateMove(source, target, piece, false) !== 'snapback') {
            return;
        } else {
            count++;
            if (count >= 2) {
                pieces.forEach(element => {
                    $(`.square-${element}`).addClass('temporary-border');
                });
                $('.temporary-border').css('border', '1px solid red');
                setTimeout(function () {
                    $('.temporary-border').css('border', '');
                }, 4000)
                hideMagnus();
            }
        }
    }
    var onSnapEnd = function (source, target, piece) {
        clearTimeout(timer);
        hideMagnus();
        let boardFen = ChessBoard.board.fen();
        if (results.includes(boardFen)) {
            let index = results.indexOf(boardFen);
            if (index > -1) {
                $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
                $(`#box-${squares[star]}`).css('background-color', 'green');
                $(`#box-${squares[star]}>.box-content`).remove();
                $(`#box-${squares[star]}`).css('margin-top', '16px').prepend('<img class="yellow-star" style="height: 100%; width: 100%;" src="/img/yellow_star_1.svg" />');
                results.splice(index, 1);
                star++;
            }
            if (results.length === 0) {
                setTimeout(function () {
                    showMagnus({
                        data: 'Good job!',
                        position: 'left',
                        styleClass: 'md'
                    })
                    $('.right-content-holder').remove();
                    loadNextConfiguration(3000, next, true);
                }, 1000)
            }
            setTimeout(function () {
                ChessBoard.board.position(finalBoardPosition);
                ChessBoard.game = new window.Chess(finalBoardPosition + BLACK_INITIAL_MOVE);
            }, 2000)
        } else {
            if (count >= 2) {
                count = 0;
                pieces.forEach(element => {
                    $(`.square-${element}`).addClass('temporary-border');
                });
                $('.temporary-border').css('border', '1px solid red');
                setTimeout(function () {
                    $('.temporary-border').css('border', '');
                }, 4000)
                showMagnus({
                    data: 'These are the pieces you need to give attention to!',
                    position: 'left',
                    styleClass: 'lg'
                })
            } else {
                count++;
                $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
                showMagnus({
                    data: 'That\'s not the right move',
                    position: 'left',
                    styleClass: 'md'
                })
                hideMagnus();
                ChessBoard.board.position(finalBoardPosition);
                ChessBoard.game = new window.Chess(finalBoardPosition + BLACK_INITIAL_MOVE);
                return 'snapback';
            }
            ChessBoard.board.position(initialBoardPosition);
            ChessBoard.game = new window.Chess(initialBoardPosition + BLACK_INITIAL_MOVE);
            firstComputerMove();
            return 'snapback';
        }
    };

    const chessConfig = {
        config: {
            position: initialBoardPosition,
            next: next,
            onDragStart: onDragStart,
            onDrop: onDrop,
            onSnapEnd: onSnapEnd,
            draggable: true,
            sparePieces: true,
            moveSpeed: 1000
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}

/**
 * @name lesson20Assignment2
 * @function
 * @param { config }
 * @description: Make a mate
 */

export function lesson20Assignment2(config) {
    let next = config.next,
        moveSpeed = 1000,
        initialBoardPosition = config.position,
        magnusText = config.magnusText,
        magnusInitialText = config.magnusInitialText,
        timer, initialTimer,
        moves = config.moves,
        totalStudentMoves = moves.studentMove.from.length,
        totalComputerMoves = moves.computerMove.from.length,
        studentFromCount = 0,
        studentToCount = 0,
        computerFromCount = 0,
        computerToCount = 0,
        board;

    let afterLoad = function () {
        prepareChessboard(config);
        $('.next-btn-container #next, .back-btn-container #previous').click(function () {
            studentFromCount = 0;
            studentToCount = 0;
            computerFromCount = 0;
            computerToCount = 0;
            clearTimeout(initialTimer);
            clearTimeout(timer);
        });
        initialTimer = setTimeout(function () {
            showMagnus({
                data: magnusInitialText,
                position: 'left',
                styleClass: 'lg'
            }, 1000)
        }, 5000)
    }

    let onDragStart = function (source, piece, position, orientation) {
        board = ChessBoard.board.fen();
        return restrictMove(piece, config.restrictMoveOf);
    }

    let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
        // return validateMove(source, target, piece, false);
        ChessBoard.game.move({
            from: source,
            to: target
        });
    }

    var onSnapEnd = function (source, target, piece) {
        $(document).trigger('bubble-hide');
        clearTimeout(initialTimer);
        if (studentFromCount < totalStudentMoves && studentToCount < totalStudentMoves) {
            if (source === moves.studentMove.from[studentFromCount] && target === moves.studentMove.to[studentToCount]) {
                $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
                studentFromCount++;
                studentToCount++;
                if (studentFromCount === totalStudentMoves && studentToCount === totalStudentMoves) {
                    showMagnus({
                        data: `Nice job ${User.user.name}!`,
                        position: 'left',
                        styleClass: 'md'
                    })
                    loadNextConfiguration(4000, next, true);
                }
                computerMove();
            } else {
                $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
                showMagnus({
                    data: 'That\'s not the right move',
                    position: 'left',
                    styleClass: 'md'
                })
                setTimeout(function () {
                    $(document).trigger('bubble-hide');
                }, 3000)
                ChessBoard.board.position(board);
                ChessBoard.game = new window.Chess(board + config.initialMoveOf);
            }
        }

        function computerMove() {
            if (computerFromCount < totalComputerMoves && computerToCount < totalComputerMoves) {
                timer = setTimeout(function () {
                    ChessBoard.board.move(moves.computerMove.from[computerFromCount] + '-' + moves.computerMove.to[computerToCount]);
                    computerFromCount++;
                    computerToCount++;
                }, 2000);
                let boardFen = ChessBoard.board.fen();
                ChessBoard.board.position(boardFen);
                ChessBoard.game = new window.Chess(board + config.initialMoveOf);
            }
        }
    }

    const chessConfig = {
        config: {
            next: next,
            magnusText: magnusText,
            position: initialBoardPosition,
            onDragStart: onDragStart,
            onDrop: onDrop,
            onSnapEnd: onSnapEnd,
            draggable: true,
            sparePieces: true,
            moveSpeed: moveSpeed
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}

/**
 * @name lesson20Assignment3
 * @function
 * @param { config }
 * @description: Place the piece in the right square
 */

export function lesson20Assignment3(config) {
    let position = config.position,
        next = config.next,
        fen = config.fen,
        pieceLimit = config.pieceLimit,
        piecesArray = config.piecesArray ? config.piecesArray : [],
        validatePieces = config.validatePieces ? config.validatePieces : [],
        tryCount = 2;

    let afterLoad = function () {
        prepareChessboard(config);
    }

    let onDragStart = function (source, piece, position, orientation) {
        validateDrag(piece, pieceLimit[piece]);
    }

    let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
        let bubbleConfig = {
            data: `Good job ${User.user.name}!`,
            position: 'left',
            styleClass: 'xs'
        };
        validatePosition(piecesArray.length, fen, next, bubbleConfig, false, true);
        if (validateDrop(piece, pieceLimit[piece], target, validatePieces, true) === 'trash') {
            if (tryCount === 0) {
                setTimeout(function () {
                    showMagnus({
                        data: 'This is where you need to place the piece',
                        position: 'left',
                        styleClass: 'lg'
                    });
                }, 1000)
                tryCount = 2;
                loadNextConfiguration(4000, next - 1, false);
            }
            tryCount--;
        }
        return validateDrop(piece, pieceLimit[piece], target, validatePieces, true)
    }

    function validatePosition(pieceLimit, resultFen, next, bubbleConfig = null, isQA = false, celebrationSound) {
        if ($(".piece-417db").length >= (12 + pieceLimit)) {
            setTimeout(function () {
                let fen = ChessBoard.board.fen()

                if (fen === resultFen) {
                    if (celebrationSound) {
                        $(document).trigger('audio-play', ACTIVITY_SUCCESS_AUDIO);
                    }
                    showMagnus(bubbleConfig)
                    loadNextConfiguration(2000, next - 1, celebrationSound)
                }
            }, 100)
        }
    }

    const chessConfig = {
        config: {
            position: position,
            draggable: true,
            dropOffBoard: 'trash',
            sparePieces: true,
            onDrop: onDrop,
            onDragStart: onDragStart,
            pieceTheme: `img/chesspieces/${config.pieceTheme}/{piece}.svg`
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}

/**
* @name lesson20Assignment4
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson20Assignment4(config) {
    let offsetFromx = null,
        offsetFromy = null,
        offsetTox = null,
        offsetToy = null,
        from = config.from,
        to = config.to,
        fromCount = from.length,
        toCount = to.length,
        color = config.color,
        colorCount = color.length;

    if (config.offset) {
        offsetFromx = config.offset[0]
        offsetFromy = config.offset[1]
        offsetTox = config.offset[2]
        offsetToy = config.offset[3]
    }

    let afterLoad = function () {
        prepareChessboard(config);

        $('#myCanvas').addClass('show').removeClass('hide');
        var c = document.getElementById("myCanvas");
        var ctx = c.getContext("2d");
        ctx.clearRect(0, 0, c.width, c.height);

        setTimeout(function () {
            while (fromCount > 0 && toCount > 0) {
                plotArrow(ctx, from[fromCount - 1], to[toCount - 1], offsetFromx, offsetFromy, offsetTox, offsetToy, null, null, color[colorCount - 1]);
                fromCount--;
                toCount--;
                colorCount--;
            }
        }, 1000)

        setTimeout(function () {
            ctx.clearRect(0, 0, c.width, c.height);
            loadNextConfiguration(500, config.next, false);
        }, 3000);
    }

    const chessConfig = {
        config: {
            position: config.position,
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}



// WEBPACK FOOTER //
// ./src/lessons/lesson_20/assignments.js